import React, { useEffect, useRef, useState } from 'react';
import Icon from '@@Components/Icon/Icon';
import { useClickOutside } from '@@Hooks/useClickOutside';
import dayjs from 'dayjs';
import { Datepicker as Calendar } from './utils/datepicker';
import { DatepickerValidation } from './utils/datepicker-validation';
import { DatepickerMode } from './utils/datepicker-mode';
import { DatepickerSelection } from './utils/datepicker-selection';
import { DatepickerContent } from './DatepickerContent';
import { DatepickerExpandIcon, DatepickerInput, DatepickerLabel, DatepickerPlaceholder, DatepickerWrapper } from './styled';
import { DatepickerRange } from './utils/datepicker-range';
export const Datepicker = ({ value, validation = DatepickerValidation.NONE, mode = DatepickerMode.SINGLE, selection = DatepickerSelection.NONE, range = DatepickerRange.DAY, onChange = () => { }, placeholder = '', format = 'MMMM YYYY', outputFormat, error, label, options, required, minimalDate, blockSunday, }) => {
    const [opened, setOpened] = useState(false);
    const [calendar, setCalendar] = useState(null);
    const [date, setDate] = useState(value);
    const ref = useRef();
    const inputRef = useRef();
    const handleDateChange = (date) => {
        calendar.selectDate(date);
        setDate(date);
        const selected = calendar.getCalendarDate();
        let output = selected.length === 1 ? selected[0] : selected;
        if (outputFormat)
            output = dayjs(output).format(outputFormat);
        onChange(output);
        if (mode === DatepickerMode.SINGLE) {
            setOpened(false);
        }
    };
    useEffect(() => {
        const cal = new Calendar(value, validation, mode, selection);
        setCalendar(cal);
    }, []);
    useEffect(() => {
        setDate(value);
    }, [value]);
    useClickOutside(ref, () => setOpened(false), [inputRef]);
    return React.createElement(DatepickerWrapper, { placeholder: placeholder, ref: ref },
        React.createElement(DatepickerInput, { error: !!error, onClick: () => setOpened(!opened) },
            label && (React.createElement(DatepickerLabel, null, `${required ? '*' : ''}${label}`)),
            React.createElement(DatepickerPlaceholder, { isSelected: !!date }, date ? Calendar.placeholderFormatted(calendar.getSelectedDate(), range) : placeholder),
            React.createElement(DatepickerExpandIcon, { onClick: () => setOpened(false) },
                React.createElement(Icon, { icon: 'expand', width: 12, rotate: opened ? '180' : '0' }))),
        opened && (React.createElement(DatepickerContent, { minimalDate: minimalDate, blockSunday: blockSunday, datepicker: calendar, format: format, options: options, onDateChange: handleDateChange })));
};
